<mat-dialog-content>
  {{data.message | async}}

  @if (data.messagesList.length > 0) {
    <ul class="messages-list">
      @for (m of data.messagesList; track m) {
        <li>
          {{m | translate}}
        </li>
      }
    </ul>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="false" id="no" type="button" mat-flat-button>{{data.labels.noLabel | async}}</button>
  <button [mat-dialog-close]="true" id="yes" type="button" mat-flat-button color="warn">{{data.labels.yesLabel | async}}</button>
</mat-dialog-actions>
